import groq from 'groq'
import pageFields from '../fields/page'
import productFields from '../fields/product'
import linkField from '../fields/link'
import imageField from '../fields/image'
import galleryField from '../fields/gallery'
import socialMediaField from '../fields/social-media'
import pressField from '../fields/press'

export default ({ category, slug }, id) => {
  let query
  if (id) {
    query = `_id == "${id}"`
  } else {
    query = `_type == "product" && slug.current == "${slug}" && references(*[_type=="productCategory" && slug.current == "${category}"]._id)`
  }
  return groq`
    *[${query}][0]{
      ...${pageFields},
      ...${productFields},
      'categoryPartial': category->{
        showTestimonials,
        showPress,
        backgroundImages[] {
          ...,
          asset-> {
            ...
          }
        }
      },
      colorSectionBackground,
      heroGallery[]{
        ...${galleryField}
      },
      favicon,
      description,
      gallery{
        gallery[]{
          ...${galleryField}
        },
        defined(link.page) || defined(link.url) => {
          link{
            ...${linkField}
          }
        }
      },
      relatedSocialMedia{
        title,
        socialMedia[]{
          ...${socialMediaField}
        }
      },
      ingredients[]->{
        ...,
        image{
          ...${imageField}
        }
      },
      features{
        ...,
        link{
          ...${linkField}
        }
      },
      featuredPress[]->{
        ...${pressField}
      },
      relatedProductsTitleLink{
        ...${linkField}
      },
      relatedProducts{
        featured->{
          ...${pageFields},
          ...${productFields},
          cbd,
          description,
        },
        products[]->{
          cbd,
          ...${pageFields},
          ...${productFields}
        }
      },
      amazonLink,
      amazonCta,
      hideFromCollection,
      hideFromNavigation,
    }
  `
}
